import { RouteConfig } from 'vue-router'
import { requireAuthAndLocation } from '../../auth'

const ProposalsEstimationsTemplateListPage = () =>
    import('@/pmd/pages/payments/ProposalsTemplateList.vue')

export const DocumentsContractsTemplateListRoute: RouteConfig[] = [
    {
        path: 'payments/proposals-estimates/templates',
        name: 'proposals-estimates-templates',
        component: ProposalsEstimationsTemplateListPage,
        beforeEnter: requireAuthAndLocation,
        children: [],
    },
]